import { Component, h, Prop } from '@stencil/core'
import { trans } from '~/store'

@Component({
    tag: 'zr-bannerx-hero',
    styleUrl: 'zr-bannerx-hero.scss',
    shadow: true,
})

/**
 * ZooRoyal Banner X Hero.
 */
export class ZrBannerxHero {
    /**
     * The aria label for the image.
     */
    @Prop() ariaLabel: string

    /**
     * The hero image.
     */
    @Prop() backgroundImage: string

    /**
     * The mobile hero image.
     */
    @Prop() mobileImage: string

    /**
     * The mobile hero image.
     */
    @Prop() heroImage: string

    /**
     * The CTA Link.
     */
    @Prop() ctaLink: string

    /**
     * The CTA Text.
     */
    @Prop() ctaText: string

    /**
     * Renders the component.
     */
    render() {
        return (
            <a href={this.ctaLink} aria-label={this.ctaText}>
                <picture>
                    <div class="zr-bannerx-hero__badge">{
                        trans('frontend/detail/index.promotion', 'Gesponsert')
                    }</div>
                    <source
                        srcSet={this.backgroundImage}
                        type={'image/jpeg'}
                        media={'(min-width: 768px)'}
                    />
                    <img
                        class="zr-bannerx-hero__image"
                        src={this.mobileImage}
                        alt={this.ariaLabel}
                        loading='eager'
                    />
                </picture>
                {(this.heroImage) && (
                    <div class="zr-bannerx-hero__hero-image-wrapper">
                        <img class="zr-bannerx-hero__hero-image" src={this.heroImage} alt={this.ariaLabel} />
                    </div>
                )}
            </a>
        )
    }
}
